export default __webpack_public_path__ + "static/media/org_parent.f6ca5237.svg";